import axios from "axios";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import useSWR from "swr";

const WEB_BLOG_ROOT_URL = "https://solitairetripeaks.com/wp-json/";

export interface IWebWinnersReturn {
	posts: [];
	setPosts: Dispatch<SetStateAction<[]>>;
	currentNewsListScrollPosition: number;
	setCurrentNewsListScrollPosition: Dispatch<SetStateAction<number>>;
	setSearchTerm: Dispatch<SetStateAction<string | null>>;
	searchTerm: string | null;
	resetNewsState: () => void;
	currentPageNum: number;
	setCurrentPageNum: Dispatch<SetStateAction<number>>;
	perPage: number;
	setPerPage: Dispatch<SetStateAction<number>>;
	totalPages: number;
	setTotalPages: Dispatch<SetStateAction<number>>;
	totalPosts: number;
	setTotalPosts: Dispatch<SetStateAction<number>>;
	error: Error | null;
	isLoading: boolean;
}

export const useWebWinners = (): IWebWinnersReturn => {
	const [perPage, setPerPage] = useState(12);
	const [posts, setPosts] = useState<[]>([]);
	const [currentNewsListScrollPosition, setCurrentNewsListScrollPosition] =
		useState<number>(0);
	const [searchTerm, setSearchTerm] = useState<string | null>(null);
	const [currentPageNum, setCurrentPageNum] = useState(1);
	const [totalPages, setTotalPages] = useState(0);
	const [totalPosts, setTotalPosts] = useState(0);

	// For list of categories:
	// https://solitairetripeaks.com/wp-json/wp/v2/categories
	const { data, error, isLoading } = useSWR(
		`${WEB_BLOG_ROOT_URL}wp/v2/posts?${
			searchTerm ? `search=${searchTerm}&` : ""
		}per_page=${perPage}&page=${currentPageNum}&categories=1359`,
		axios
	);

	const resetNewsState = () => {
		setCurrentPageNum(1);
		setSearchTerm(null);
		setCurrentNewsListScrollPosition(0);
	};

	// set posts data returned from api
	useEffect(() => {
		if (data?.data) {
			setPosts(data.data);
		}
		if (data?.headers) {
			setTotalPages(parseInt(data.headers["x-wp-totalpages"]) || 0);
			setTotalPosts(parseInt(data.headers["x-wp-total"]) || 0);
		}
	}, [data]);

	return {
		perPage,
		setPerPage,
		posts,
		setPosts,
		currentNewsListScrollPosition,
		setCurrentNewsListScrollPosition,
		totalPages,
		setTotalPages,
		totalPosts,
		setTotalPosts,
		searchTerm,
		setSearchTerm,
		currentPageNum,
		setCurrentPageNum,
		resetNewsState,
		error,
		isLoading
	};
};
